const article = {
  id: 9,
  category: "Transformation digitale",
  title: "Mesurer les gains de la transformation digitale : Méthodes et outils",
  text: "Coûts, délais, qualité, productivité… Comment évaluer l’impact réel de votre digitalisation ? Nos outils et benchmarks pour piloter votre projet.",
  link: "/articles/mesurer-gains-transformation-digitale",
  date: "Novembre 2025",
  highlight: "Baromètre Niji 2025 : Les clés d’une transformation réussie"
};

export default article;
